/*
 * EnvironmentBanner
 *
 * Renders a persistent, undismissable yellow bar at the top of the SPA when
 * REACT_APP_ENV is "staging".  Returns null in any other environment.
 *
 * Why not read this from an API response: we want the banner to show
 * IMMEDIATELY on page load, before any API call has returned — otherwise a
 * tester could file a "lost my gift" bug before realising they were on
 * staging.  Build-time env vars are guaranteed available before the first
 * render.
 *
 * The Blade page (resources/views/welcome.blade.php) has its own equivalent
 * banner for any server-rendered page someone hits directly on the backend.
 */
export default function EnvironmentBanner() {
    const env = process.env.REACT_APP_ENV;

    if (env !== 'staging') {
        return null;
    }

    return (
        <div
            // role + aria-label so screen readers announce it
            role="status"
            aria-label="Staging environment warning"
            style={{
                backgroundColor: '#facc15',  // Tailwind yellow-400
                color: '#422006',            // Tailwind amber-950
                padding: '10px 16px',
                textAlign: 'center',
                fontWeight: 600,
                fontSize: 14,
                letterSpacing: '0.02em',
                borderBottom: '2px solid #ca8a04',
                position: 'sticky',
                top: 0,
                zIndex: 9999,
            }}
        >
            STAGING ENVIRONMENT — For testing only, not real gifting.
        </div>
    );
}
